import type { ComponentChildren } from "preact";
import { cx } from "./lib/cx.ts";

/** A soft panel for a side rail: heading row (title plus an optional action such as an EditButton) over a body. Rule: use it for the rail only; a page's main content sits on the page or in a List, not in panels. */
export function RailPanel({ title, action, children, class: className }: { title: ComponentChildren; action?: ComponentChildren; children?: ComponentChildren; class?: string }) {
  return (
    <section class={cx("ui-panel", className)}>
      <div class="ui-panel__head">
        <h3 class="ui-panel__title">{title}</h3>
        {action}
      </div>
      <div class="ui-panel__body">{children}</div>
    </section>
  );
}
